export default __webpack_public_path__ + "static/media/avant.c15087a7.woff2";